<!-- 查看详情 -->
<template>
  <div class="info" v-loading="loading">
    <back />

    <el-form :model="ruleForm" ref="ruleForm" label-width="155px" class="demo-ruleForm">
      <div class="form">

        <div class="title">基础信息：</div>
        <el-divider class="dividers"></el-divider>
        <div class="container">
          <div class="item">直播间名称：{{ ruleForm?.liveName }}</div>
          <div class="item">直播间分类：{{ ruleForm?.categoryName }}</div>
          <div class="item">直播主讲专家: {{ ruleForm?.teacherName }}</div>
          <div class="item">是否收费:
            <span v-if="ruleForm.costAttr == 0">否</span>
            <span v-if="ruleForm.costAttr == 1">是</span>
          </div>
          <div class="item" v-if="ruleForm.costAttr == 1">直播价格(元)：{{ ruleForm?.price }}</div>
          <div class="item">开播时间: {{ ruleForm?.startTime }}</div>
          <div class="item">结束时间: {{ ruleForm?.endTime }}</div>
          <div class="item">是否推荐:
            <span v-if="ruleForm?.recommendFlag == 0">否</span>
            <span v-if="ruleForm?.recommendFlag == 1">是</span>
          </div>
          <div class="item pic">
            <span class="text">直播间封面:</span>
            <el-image style="width: 100px; height: 100px" :src='ruleForm?.livePic' fit="fill"
              :preview-src-list="[ruleForm?.livePic]"></el-image>
          </div>
        </div>

        <div class="title">开播信息：</div>
        <el-divider class="dividers"></el-divider>
        <div class="container">
          <div class="item">PC直播Url: {{ ruleForm?.liveUrl }}</div>
          <div class="item">PC直播频道号: {{ ruleForm?.channelNumber }}</div>
          <div class="item">PC直播登录密码: {{ ruleForm?.livePassword }}</div>
          <div class="item pic">
            <span class="text">小程序开播二维码:</span>
            <el-image style="width: 100px; height: 100px" :src='ruleForm?.mpLiveUrl' fit="fill"
              :preview-src-list="[ruleForm?.mpLiveUrl]"></el-image>
          </div>
        </div>
        <div class="title">开播信息：</div>
        <el-divider class="dividers"></el-divider>
        <div class="container">
          <div class="item">H5观看Url: {{ ruleForm?.playUrl }}</div>
          <div class="item">小程序观看地址: {{ ruleForm?.mpPlayUrl }}</div>
        </div>
        <div class="container">
          <div class="item ">直播间简介：<div v-html="ruleForm?.introduce"></div>
          </div>
        </div>


      </div>

    </el-form>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      ruleForm: {

      },
    }
  },
  created() {
    this.selectLiveInfoDetail();
  },
  methods: {
    selectLiveInfoDetail() {
      this.loading = true;
      this.$axios.get(this.$api.selectLiveInfoDetail, {
        params: {
          id: this.$route.query.id,
        }
      }).then((res) => {
        if (res.code == 100) {
          this.ruleForm = res.result
          const regex = new RegExp('<img', 'gi')
          if (this.ruleForm.introduce) {
            this.ruleForm.introduce = res.result.introduce.replace(regex, `<img style="max-width: 100%; height: auto;"`);
          }
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.info {
  .form {
    margin: 30px 20px;

    .title {
      font-size: 18px;
      font-weight: bold;
    }

    .dividers {
      background-color: #f0f1f1;
    }

    .container {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 30px;
      font-size: 16px;
      color: #707070;
    }

    .item {
      width: 32%;
      /* 100% / 3 = 33.33%，留一点空间避免浏览器计算误差 */
      margin-bottom: 30px;
    }

    .container .item:nth-last-child(-n+3) {
      margin-bottom: 0;
    }

    ::v-deep .el-checkbox__label,
    ::v-deep .el-radio__label {
      color: #707070;
      font-size: 16px;
    }
  }

  .pic {
    display: flex;

    .text {
      margin-right: 15px;
    }
  }
}
</style>
